import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export type AddPersonFormSchemaType = {
  firstname: string;
  lastname: string;
};

type UseFormSchemaReturnType = UseFormReturn<AddPersonFormSchemaType>;

const TRANS_KEY = 'ADD_PERSON_MODAL.FORM_ERRORS';

export const useAddPersonForm = (): UseFormSchemaReturnType => {
  const { t } = useTranslation('common');

  const formSchema = z.object({
    firstname: z.string().min(2, {
      message: t(`${TRANS_KEY}.FIRSTNAME_REQUIRED`),
    }),
    lastname: z
      .string()
      .min(2, { message: t(`${TRANS_KEY}.LASTNAME_REQUIRED`) }),
  });

  const defaultValues: AddPersonFormSchemaType = {
    firstname: '',
    lastname: '',
  };

  const form = useForm<AddPersonFormSchemaType>({
    defaultValues,
    resolver: zodResolver(formSchema),
  });

  return form;
};
